import { all, call, put, take, takeLatest } from 'redux-saga/effects';
import { createNewBusinessInformation} from '../requests/BusinessInformationRequests.js';
import * as uiActions from '../actions/Actions.js';
import * as businessInformationActions from '../actions/BusinessInformationActions.js';
import _ from 'lodash';
import { businessInformationFields } from '../config/Fields.js';

/**
 * Returns an Employee object for api calls
 * @param {Object} user holds all accountUser settings
 */

const formDataForBusinessIOnformation = businessInfo => {
    const data = {};
    _.forEach(_.pick(businessInfo, businessInformationFields ), (value, key) => {
            {
                data[`BusinessInformation[${key}]`] = value;
            }
        }
    );
    return data;
};

export function* addBusiness({ businessInformation, callback }) {
    try {
        const data = formDataForBusinessIOnformation(businessInformation);
        const newBusinessInformation = yield call(createNewBusinessInformation, data);

        yield put(businessInformationActions.addBusinessSuccess(newBusinessInformation));
        callback(newBusinessInformation);
     
    } catch (error) {
        if (callback) {
            callback(false);
        }
        yield put(uiActions.showToast(error.message, 'negative'));
    }
}


export default function* root() {
    yield all([
        takeLatest(['ADD_BUSINESS'], addBusiness),
    ]);
}
